import { ComponentStyleConfig } from "@chakra-ui/react";

const CalendarTheme: ComponentStyleConfig = {
  baseStyle: {
    calendar: {
      bg: "unset",
      border: "none",
      shadow: "none",
    },
    months: {
      mb: 0,
      p: 0,
    },
    month: {
      borderRightColor: "magenta",
      borderRight: "5px",
    },
  },
};

export default CalendarTheme;
